export { default } from "~/pages/resource/index";

import { getListingProps } from "~/modules/static-paths";

export async function getStaticProps() {
    return getListingProps({ type: "posts", page: 1 });
}
